import {CookiePreferences} from '../types';

export function isCookiePreferencesChanged(
  previous: CookiePreferences,
  current: CookiePreferences
): boolean {
  return (
    previous.statistics !== current.statistics ||
    previous.marketing !== current.marketing
  );
}
